<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()" *ngIf="dialogRef">
        <mat-icon>close</mat-icon>
    </button>
    <i class="icon-phone text-blue"></i>
    <p class="mat-headline my-5" [innerHTML]="'dialog.phone.description'|translate"></p>
    <h2 class="mat-display-2 text-blue font-weight-bold mb-5" [innerHTML]="'dialog.phone.phones'|translate"></h2>
    <p class="hours text-center mb-0" [innerHTML]="'dialog.phone.hours'|translate"></p>
</div>
